module.exports = __webpack_public_path__ + "img/lib_region_flag_by.52e64ce7.png";